import { defineComponent } from 'vue'
import NoAuth from '~/layouts/NoAuth.vue'
import Auth from '~/layouts/Auth.vue'
import AuthWithoutMenu from '~/layouts/AuthWithoutMenu.vue'
import AuthWithoutProperty from '~/layouts/AuthWithoutProperty.vue'
import AuthSetting from '~/layouts/AuthSetting.vue'

export enum Layouts {
  NO_AUTH = 'NoAuth',
  AUTH = 'Auth',
  AUTH_WITHOUT_MENU = 'AuthWithoutMenu',
  AUTH_WITHOUT_PROPERTY = 'AuthWithoutProperty',
  AUTH_SETTING = 'AuthSetting',
}

export const LayoutComponents: Record<Layouts, ReturnType<typeof defineComponent>> = {
  [Layouts.NO_AUTH]: NoAuth,
  [Layouts.AUTH]: Auth,
  [Layouts.AUTH_WITHOUT_MENU]: AuthWithoutMenu,
  [Layouts.AUTH_WITHOUT_PROPERTY]: AuthWithoutProperty,
  [Layouts.AUTH_SETTING]: AuthSetting,
}
